'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ExerciseBook(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === undefined ? 64 : _ref$size,
      _ref$icon = _ref.icon,
      icon = _ref$icon === undefined ? null : _ref$icon;

  return _react2.default.createElement(
    'div',
    { style: { width: size, height: size + 9 }, className: 'jsx-3383499909' + ' ' + 'holder'
    },
    _react2.default.createElement(
      'div',
      {
        className: 'jsx-3383499909' + ' ' + 'icon'
      },
      icon
    ),
    _react2.default.createElement(
      'svg',
      {
        width: size,
        height: size + 6,
        viewBox: '0 0 43 49',
        version: '1.1',
        xmlnsXlink: 'http://www.w3.org/1999/xlink',
        className: 'jsx-3383499909'
      },
      _react2.default.createElement(
        'g',
        {
          transform: 'translate(-5.000000, -3.000000)',
          stroke: 'none',
          strokeWidth: 1,
          fill: 'none',
          fillRule: 'evenodd',
          className: 'jsx-3383499909'
        },
        _react2.default.createElement('path', {
          d: 'M48 46.465C48 49.522 45.35 52 42.078 52H14.61C11.511 52 9 49.522 9 46.465V15.536C9 12.48 11.511 10 14.611 10h27.467C45.349 10 48 12.479 48 15.536v30.929z',
          fill: '#49497F',
          className: 'jsx-3383499909'
        }),
        _react2.default.createElement('path', {
          d: 'M46 43.465C46 46.52 43.62 49 40.685 49h-25.61C12.825 49 11 47.14 11 44.848V11.152C11 8.86 12.825 7 15.075 7h25.61C43.621 7 46 9.479 46 12.535v30.93z',
          fill: '#F6F6F6',
          className: 'jsx-3383499909'
        }),
        _react2.default.createElement('path', {
          d: 'M46 42.465C46 45.52 43.62 48 40.685 48h-24.93C13.128 48 11 45.832 11 43.156V10.844C11 8.168 13.129 6 15.754 6h24.931C43.621 6 46 8.479 46 11.536v30.929z',
          fill: '#E3E3E3',
          className: 'jsx-3383499909'
        }),
        _react2.default.createElement('path', {
          d: 'M46 41.465C46 44.52 43.62 47 40.685 47h-24.93C13.128 47 11 44.832 11 42.156V9.844C11 7.168 13.129 5 15.754 5h24.931C43.621 5 46 7.479 46 10.535v30.93z',
          fill: '#CECECE',
          className: 'jsx-3383499909'
        }),
        _react2.default.createElement('path', {
          d: 'M46 39.465C46 42.522 43.62 45 40.685 45h-24.93C13.128 45 11 42.832 11 40.156V7.844C11 5.168 13.129 3 15.754 3h24.931C43.621 3 46 5.479 46 8.536v30.929z',
          fill: '#F6F6F6',
          className: 'jsx-3383499909'
        }),
        _react2.default.createElement('path', {
          d: 'M9.363 43C6.499 43 5 40.971 5 38.967 5 36.995 6.499 35 9.363 35h3.905c.405 0 .732.302.732.702 0 .403-.327.702-.732.702H9.363c-.922 0-1.68.275-2.196.798a2.488 2.488 0 0 0-.702 1.765c0 1.266.908 2.629 2.898 2.629V43zm0-8C6.499 35 5 32.971 5 30.967 5 28.995 6.499 27 9.363 27h3.905c.405 0 .732.302.732.702 0 .404-.327.702-.732.702H9.363c-.922 0-1.68.275-2.196.798a2.49 2.49 0 0 0-.702 1.765c0 1.266.908 2.63 2.898 2.63V35zm28.844-20.016L26.795 15c-.44 0-.795-.443-.795-.991-.001-.547.354-.991.793-.993L38.205 13c.44 0 .795.443.795.99.001.548-.354.994-.793.994m-3.006 3l-8.4.016c-.442 0-.8-.443-.801-.99 0-.548.357-.992.799-.994l8.4-.016c.443 0 .801.443.801.991.001.547-.356.993-.799.993m3.006 7L26.795 25c-.44 0-.795-.443-.795-.99-.001-.548.354-.992.793-.994L38.205 23c.44 0 .795.443.795.991.001.547-.354.993-.793.993m-3.006 3l-8.4.016c-.442 0-.8-.443-.801-.99 0-.55.357-.994.799-.995l8.4-.015c.443-.001.801.442.801.99.001.55-.356.994-.799.994m3.006 8L26.795 36c-.44 0-.795-.443-.795-.99-.001-.548.354-.992.793-.994L38.205 34c.44 0 .795.443.795.991.001.547-.354.993-.793.993m-3.006 3l-8.4.016c-.442 0-.8-.443-.801-.99 0-.55.357-.994.799-.994l8.4-.016c.443-.001.801.442.801.99.001.55-.356.994-.799.994',
          fill: '#878E91',
          className: 'jsx-3383499909'
        }),
        _react2.default.createElement('path', {
          d: 'M23 23.997a2 2 0 1 1-4 .005 2 2 0 0 1 4-.005m0 11a2 2 0 1 1-4 .005 2 2 0 0 1 4-.005',
          fill: '#666B6D',
          className: 'jsx-3383499909'
        }),
        _react2.default.createElement('path', {
          d: 'M9.363 26C6.499 26 5 23.971 5 21.967 5 19.995 6.499 18 9.363 18h3.905c.405 0 .732.302.732.702 0 .404-.327.702-.732.702H9.363c-.922 0-1.68.275-2.196.798a2.49 2.49 0 0 0-.702 1.765c0 1.266.908 2.63 2.898 2.63V26zm0-9C6.499 17 5 14.971 5 12.967 5 10.995 6.499 9 9.363 9h3.905c.405 0 .732.303.732.702 0 .404-.327.702-.732.702H9.363c-.922 0-1.68.276-2.196.798a2.49 2.49 0 0 0-.702 1.765c0 1.266.908 2.63 2.898 2.63V17z',
          fill: '#878E91',
          className: 'jsx-3383499909'
        }),
        _react2.default.createElement('path', {
          d: 'M18.381 14.501a1.546 1.546 0 0 1-.004-2.028 1.189 1.189 0 0 1 1.804-.004l.954 1.073 3.684-4.13a1.188 1.188 0 0 1 1.804.004c.504.569.502 1.46-.004 2.028l-4.59 5.144a1.19 1.19 0 0 1-1.805-.004 1.468 1.468 0 0 1-.1-.126L18.381 14.5z',
          fill: '#1ABC9C',
          className: 'jsx-3383499909'
        })
      )
    ),
    _react2.default.createElement(
      _style2.default,
      {
        id: '3383499909'
      },
      ['.green.jsx-3383499909{fill:#00b083;}', '.purple.jsx-3383499909{fill:#7878cb;}', '.gray.jsx-3383499909{fill:#767c7c;}', '.holder.jsx-3383499909{position:relative;display:inline-block;}', '.icon.jsx-3383499909{position:absolute;bottom:-10%;right:-5%;z-index:2;}']
    )
  );
}

ExerciseBook.propTypes = {
  size: _propTypes2.default.number,
  icon: _propTypes2.default.node
};

exports.default = ExerciseBook;